import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { ViewabilityProvider } from '../../viewability/viewabilityHandler';
import { Article } from './Article';

const componentConfigurationKey = 'postMainContent';

interface PostMainContentThemeProps {
  backgroundColor: string;
}

const getStyleForFixedComponentWidth = () => ({
  maxWidth: '100%',
  minWidth: '100%',
  [MEDIA_BREAKPOINTS.large]: {
    paddingLeft: '80px',
    maxWidth: 'calc(100% - 80px)',
    minWidth: 'calc(100% - 80px)',
  },
});

const createStyle = (backgroundColor: string) => StyleSheet.create({
  style: {
    backgroundColor,
    margin: '0 auto',
    overflow: 'hidden',
    ...getStyleForFixedComponentWidth(),
  },
});

export const PostMainContent: React.FunctionComponent = ({ children }) => {
  const { backgroundColor } = useTheme<PostMainContentThemeProps>(componentConfigurationKey);

  return (
    <ViewabilityProvider>
      <Article articleStyleClassName={css(createStyle(backgroundColor).style)}>
        {children}
      </Article>
    </ViewabilityProvider>
  );
};
